module.exports = {
	"Notify": {
		"err": "ข้อผิดพลาด",
		"errorMsg": "Net error. Please try again later",
		"suc": "สำเร็จ"
	},
	"Navigator": {
		"profile": "ข้อมูลส่วนตัว",
		"signOut": "ออกจากระบบ",
		"signIn": "เข้าระบบ",
		"signOutTips": "คุณต้องการออกจากระบบใช่ไหม",
		"tip": "ข้อแนะนำ",
		"cancel": "ยกเลิก",
		"confirm": "ยืนยัน",
		"lang": "ภาษา",
		"changeLang": "Switching language",
		"appName": "AI Merchant"
	},
	"Functional": {
		"save": "บันทึก",
		"cancel": "ยกเลิก",
		"confirm": "ยืนยัน",
		"publish": "ออกจำหน่าย",
		"clear": "ลบทั้งหมด",
		"download": "ดาวน์โหลด",
		"upload": "อัปโหลดอุปกรณ์",
		"next": "ถัดไป",
		"back": "กลับ",
		"help": "ช่วยเหลือ",
		"on": "เปิด | เปิด",
		"off": "ปิด | ปิด",
		"create": "สร้าง",
		"delete": "ลบ",
		"all": "ทั้งหมด | ข้อมูลที่เก็บทั้งหมด | สถานะทั้งหมด | ทุกประเภท | เลือกทั้งหด",
		"comingSoon": "เร็วๆนี้",
		"controlPanel": "แผงควบคุม",
		"more": "เพิ่มเติม | ข้อมูลเพิ่มเติม",
		"yes": "ใช่ | ใช่",
		"no": "ไม่ใช่ | ไม่ใช่",
		"reload": "Reload"
	},
	"Date": {
		"dateRange": "7 วันล่าสุด | 30 วันล่าสุด | 12 เดือนล่าสุด",
		"today": "วันนี้",
		"openTime": "เวลาเปิดระบบ",
		"closeTime": "เวลาปิดระบบ",
		"placeholder": "กรุณาเลือกช่วงวันที่ต้องการ"
	},
	"Chart": {
		"numberOfCustomers": "จำนวนลูกค้า",
		"numberOfOrder": "จำนวนรายการที่สั่ง",
		"arpcByOutlet": "ARPC ของแต่ละร้านค้า",
		"revenue": "รายได้",
		"trxAmount": "แต่ละช่องทาง",
		"transactionByChannel": "จำนวนรายการแต่ละช่องทาง",
		"channelPercentage": "เปอร์เซ็นต์ของแต่ละช่องทาง",
		"outletPercentage": "เปอร์เซ็นต์ของแต่ละร้านค้า",
		"statusPercentage": "เปอร์เซ็นต์ของแต่ละสถานะ",
		"customerGrowthChart": "แผนภูมิการขยายตัวของลูกค้า",
		"newCustomers": "ลูกค้าใหม่",
		"retention": "การขยาย",
		"customerCategories": "ประเภทของลูกค้า",
		"customerStatus": "สถานะของลูกค้า",
		"customerFrequency": "ความถี่ของลูกค้า",
		"customerContribution": "การสนับสนุนของลูกค้า",
		"arpcByGender": "ARPC ของแต่ละเพศ",
		"arpcByProduct": "ARPC ของแต่ละผลิตภัณฑ์",
		"outletPerChannel": "รายช่องทาง",
		"transactionsByOutlet": "จำนวนรายการแต่ละร้านค้า",
		"RefundByOutlet": "การคืนเงินของแต่ละร้านค้า",
		"ReversalByOutlet": "การยกเลิกสินค้าของแต่ละร้านค้า"
	},
	"Tab": {
		"generalStatus": "สถานะทั่วไป",
		"byChannel": "รายช่องทาง",
		"percentage": "เปอร์เซ็นต์",
		"newCustomers": "ลูกค้าใหม่",
		"customerCategories": "ประเภทของลูกค้า",
		"arpc": "รายได้เฉลี่ยของแต่ละลูกค้า",
		"customerMap": "ทิศทางของลูกค้า",
		"transactions": "รายการ",
		"outletPercentage": "เปอร์เซ็นต์"
	},
	"Button": {
		"createNewCoupon": "สร้างคูปองใหม่",
		"addNewOutlet": "เพิ่มร้านค้าใหม่",
		"chooseCouponTemplate": "เลือกแบบของคูปอง",
		"backToTemplate": "กลับสู่การเลือกรูปแบบ",
		"saveCoupon": "บันทึกคูปอง",
		"save": "บันทึก",
		"cancel": "ยกเลิก",
		"delete": "ลบ",
		"refund": "คืนเงิน"
	},
	"Placeholder": {
		"TableSearch": "เลือกประเภทรหัสประจำตัว",
		"OutletSearch": "ชื่อร้านค้า,ที่อยู่,ชื่อผู้ติดต่อ,หมายเลขโทรศัพท์เคลื่อนที่",
		"AccountSearch": "ชื่อผู้ใช้,ชื่อ,โทรศัพท์เคลื่อนที่,อีเมล"
	},
	"Step": {
		"Coupons": "เลือกประเทศ | เลือกรูปแบบ | แก้ไขคูปอง | เลือกร้านค้า"
	},
	"Country": {
		"title": "ชื่อเรื่อง",
		"China": "จีน",
		"Australia": "ออสเตรเลีย",
		"Indonesia": "อินโดนีเซีย",
		"Malaysia": "มาเลเซีย",
		"Singapore": "สิงค์โปร์",
		"SouthKorea": "เกาหลีใต้",
		"Thailand": "ไทย"
	},
	"Week": {
		"sunday": "วันอาทิตย์",
		"monday": "วันจันทร์",
		"tuesday": "วันอังคาร",
		"wednesday": "วันพุธ",
		"thursday": "วันพฤหัสบดี",
		"friday": "วันศุกร์",
		"saturday": "วันเสาร์"
	},
	"Table": {
		"id": "รหัสประจำตัว",
		"actions": "กระทำ",
		"view": "มอง | มอง | มอง",
		"stop": "หยุด",
		"update": "ปรับปรุง",
		"publish": "จำหน่าย",
		"upgrade": "ยกระดับ",
		"edit": "แก้ไข",
		"resetPassword": "ตั้งรหัสผ่านใหม่",
		"permissions": "อนุญาต"
	},
	"Views": {
		"401": {
			"title": "401",
			"cnt1": "Sorry!",
			"cnt2": "You have no access rights",
			"btn1": "",
			"btn2": "Go to Dashboard"
		},
		"404": {
			"title": "404",
			"cnt1": "Sorry",
			"cnt2": "The page could not be found",
			"btn1": "Back to prev",
			"btn2": "Go to Dashboard"
		},
		"500": {
			"title": "500",
			"cnt1": "Sorry!",
			"cnt2": "The service is temporarily unresponsive",
			"btn1": "Refresh",
			"btn2": "Go to Dashboard"
		},
		"Login": {
			"msg": "ข้อความ",
			"login": "เข้าระบบ",
			"loading": "กำลังรับข้อมูล",
			"id": "รหัสประจำตัว",
			"pwd": "รหัสผ่าน",
			"captcha": "Captcha"
		},
		"Dashboard": {
			"welTitle": "Congratulations! You have successfully activate your account!",
			"welCnt": "You can download the QR code via merchant portal. Related marketing materials and QR code will be delivered to your store within 3-5 working days."
		},
		"Transactions": {
			"filter": {
				"id": "รหัสประจำตัว",
				"mid": "รหัสร้านค้า",
				"mname": "ชื่อร้านค้า"
			},
			"table": {
				"id": "รหัสประจำตัว",
				"date": "วันที่",
				"amount": "จำนวนเงิน",
				"realAmount": "จำนวนเงินจริง",
				"status": "สถานะ",
				"outlet": "ร้าน",
				"posID": "รหัสเครื่องชำระเงิน",
				"remark": "หมายเหตุ",
				"cAmount": "Order amount",
				"customer": "ลูกค้า",
				"posUsername": "POS Username"
			},
			"downloadFileName": "รายการ"
		},
		"TrxViewDeital": {
			"table": {
				"id": "รหัส",
				"outletId": "รหัสร้าน",
				"merchantId": "รหัสร้านค้า",
				"trxId": "หมายเลขรายการ",
				"settleAmount": "จำนวนเงินที่ปิดยอด",
				"realAmount": "จำนวนเงินจริง",
				"currency": "สกุลเงิน",
				"createTime": "เวลาที่สร้าง",
				"createLocalTime": "Create local time",
				"deviceId": "รหัสอุปกรณ์",
				"status": "สถานะ",
				"subType": "ประเภทย่อย",
				"remark": "หมายเหตุ",
				"payTrxId": "Pay transaction ID",
				"payChannel": "ช่องทางการชำระเงิน",
				"customer": "ลูกค้า",
				"fee": "ค่าธรรมเนียม",
				"customerAmount": "Order amount",
				"settleTime": "เวลาปิดยอด",
				"refundRecord": "จำนวนรายการที่คืนเงิน",
				"refundStatus": "สถานะการคืนเงิน",
				"requestForRefund": "การขอคืนเงิน",
				"refunded": "คืนเงิน",
				"refundFailed": "รายการคืนเงินไม่สำเร็จ",
				"appTime": "เวลาของระบบ",
				"completeTime": "เวลาที่ทำรายการสำเร็จ",
				"refundAmount": "ยอดคืนเงิน",
				"refund": "คืนเงิน",
				"refundAbleAmount": "จำนวนเงินที่สามารถคืนเงินได้",
				"finalAmount": "ยอดสุดท้าย",
				"cRate": "Customer rate",
				"mRate": "Merchant rate",
				"discount": "Discount",
				"t1": "Basic Information",
				"posId": "POS ID",
				"cashier": "Cashier Username"
			},
			"tips": {
				"title": "Refund",
				"cnt": "This refund request cannot be cancelled. Are you sure to proceed?",
				"placeholder": "Refund password"
			},
			"transferNameList": "0 | Transfer Pending | Transfer Completed | Transfer Failed"
		},
		"Refund": {
			"table": {
				"rTime": "Refund time",
				"trxId": "Transaction ID",
				"rAmount": "Refunded amount",
				"rStatus": "Refund status",
				"customer": "ลูกค้า",
				"remark": "หมายเหตุ",
				"store": "ร้านค้า",
				"posId": "Pos ID"
			},
			"filter": {
				"trxId": "Transaction ID",
				"customer": "ร้านค้า"
			},
			"button": {
				"refund": "คืนเงิน"
			},
			"mask": {
				"title": "Pending refunded amount",
				"name": "ชื่อ",
				"amount": "จำนวนเงิน",
				"cnt": "Your settlement has been suspended. Please transfer the above amount to the agency as soon as possible to resume the settlement."
			},
			"downloadFileName": "refunds"
		},
		"RefundDetail": {
			"form": {
				"trxId": "Transaction ID",
				"cTime": "Create time",
				"ptId": "Pay Transaction ID",
				"pType": "Payment type",
				"customer": "Customer",
				"fee": "ค่าธรรมเนียม",
				"rAmount": "RefundAmount",
				"settled": "To be settled",
				"sTime": "Settlement time",
				"rComplete": "Refund Completed",
				"completeTime": "Completed time"
			}
		},
		"Customers": {
			"checkbox": {
				"all": "ทั้งหมด",
				"customerCategorization": "ประเภทของลูกค้า",
				"activeCustomers": "Active customers | Inactive customers | Lost customers",
				"frequencyCustomers": "High frequency customers | Mid frequency customers | Low frequency customers",
				"contributionCustomers": "High contribution customers | Mid contribution customers | Low contribution customers"
			},
			"table": {
				"id": "รหัสประจำตัว",
				"name": "ชื่อ",
				"mobile": "โทรศัพท์เคลื่อนที่",
				"gender": "เพศ",
				"joinDate": "วันที่เข้าร่วม",
				"totalSpending": "ยอดรวมการทำรายการ",
				"lastVisitDate": "วันที่ล่าสุดที่เข้าระบบ",
				"averageSpending": "ยอดเฉลี่ยการทำรายการ"
			}
		},
		"Coupons": {
			"CNC": "Create New Coupon",
			"AC": "Active Coupon",
			"IC": "Invaild Coupon",
			"redeem": "redeemed",
			"invalid": "Invalid",
			"none": "No data"
		},
		"CouponsTips": {
			"title": "In our system, you can easily publish your store coupon to all connected channels.",
			"tip1": "If you would like to enable this feature",
			"tip2": "please contact your MA"
		},
		"ChooseTemplate": {
			"productDiscount": "ส่วนลดของผลิตภัณฑ์",
			"storeWideOff": "Store-wide % off",
			"freeGift": "ส่วนลดของผลิตภัณฑ์",
			"cash": "เงินสด",
			"subtitle": "หัวข้อย่อย",
			"choose": "เลือก"
		},
		"CouponAgreement": {
			"btn": "I agree",
			"title": "Agreement"
		},
		"ProductDiscount": {
			"subtitle": "หัวข้อย่อย",
			"form": {
				"title": "Coupon title | Product name | Product description | Original percentage | Usage instructions",
				"description": "After discount $ {discountValue}, customers save $ {saveValue}"
			}
		},
		"Conditions": {
			"payOnline": "ชำระเงินทางออนไลน์",
			"payOnlineDescription": "คำอธิบายเพิ่มเติมของการชำระเงินออนไลน์",
			"checkboxTitle": "Can be used for",
			"checkbox": "In store purchase | Delivery order"
		},
		"Settlement": {
			"table": {
				"tDate": "Transaction date",
				"sAmount": "Settlement amount",
				"sStatus": "Settlement status",
				"sTime": "Settlement time",
				"cTime": "Upload time"
			},
			"filter": {
				"status": "สถานะ"
			},
			"transferOption": {
				"initial": "เริ่มต้น",
				"pending": "อยู่ระหว่างการดำเนินการ",
				"processing": "อยู่ระหว่างประมวลผล",
				"successful": "สำเร็จ",
				"failed": "ล้มเหลว",
				"refuse": "ปฏิเสธ"
			},
			"downloadFileName": "statement | settlement"
		},
		"Review": {
			"title": "Coupon content info | Coupon condition info"
		},
		"Outlets": {
			"table": {
				"id": "รหัสประจำตัว",
				"name": "ชื่อ",
				"country": "ประเทศ",
				"state": "รัฐ",
				"city": "เมือง",
				"address": "ที่อยู่",
				"contact": "ผู้ติดต่อ",
				"phone": "หมายเลขโทรศัพท์"
			}
		},
		"AddNewOutlet": {
			"form": {
				"name": "ชื่อ",
				"country": "ประเทศ",
				"state": "รัฐ",
				"city": "เมือง",
				"place": "สถานที่",
				"address1": "ที่อยู่ 1",
				"address2": "ที่อยู่ 2",
				"contact": "ติดต่อ",
				"phone": "หมายเลขโทรศัพท์",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude"
			}
		},
		"ViewOutletDetail": {
			"table": {
				"name": "Store name",
				"address": "Address",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude",
				"country": "Country",
				"city": "City",
				"state": "State",
				"pt": "Upload photos of store",
				"p1": "Shop inside photo",
				"p2": "Shop outside photo"
			}
		},
		"Reconciliation": {
			"table": {
				"date": "Date",
				"amount": "Amount",
				"type": "Type",
				"status": "Status",
				"outlet": "Store",
				"posID": "POS ID"
			}
		},
		"Devices": {
			"table": {
				"outlet": "Store",
				"posName": "POS name",
				"pay": "Alipay | Apple pay | Android pay | Samsung pay | Grab pay"
			}
		},
		"Accounts": {
			"table": {
				"username": "Username",
				"name": "Name",
				"mobile": "Mobile number",
				"email": "Email",
				"status": "Status",
				"lastTime": "Last login time",
				"createdAt": "Created at",
				"updatedAt": "Updated at",
				"admin": "Admin?"
			},
			"btn": {
				"add": "Create new account"
			}
		},
		"AddNewAccount": {
			"form": {
				"username": "Username",
				"name": "Name",
				"phone": "Mobile number",
				"email": "Email",
				"admin": "Admin?",
				"password": "Password",
				"status": "Status"
			}
		},
		"Password": {
			"title": "Modify Password",
			"old": "Old password",
			"new": "New password",
			"rNew": "Confirm new password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"RefundPassword": {
			"title": "Modify refund password",
			"old": "Current refund password",
			"new": "New refund password",
			"rNew": "Confirm refund password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"QrCode": {
			"title": "Merchant QR code",
			"storeTitle": "Store QR code",
			"download": "Download"
		},
		"PaymentChannel": {
			"channel": "Channel enable | Channel disable",
			"subTitle": "Customer service fee rate",
			"CBSF": "Customer Bear the Service Fee",
			"SFR": "Merchant service fee rate",
			"MBSF": "Merchant Bear the service fee",
			"err": "Customer service fee cannot be set higher",
			"than": "than",
			"cancel": "Cancel",
			"save": "Save",
			"msg": "Customer service fee cannot be set higher than",
			"msg2": "Customer service fee cannot be lower than 0%"
		},
		"Analytics": {
			"Transaction": {
				"generalStatus": "General status",
				"byChannel": "By Channel",
				"percentage": "Percentage"
			},
			"Customer": {
				"generalStatus": "General status",
				"customerCategories": "Customer categories",
				"ARPC": "Average revenue per customer (ARPC)",
				"t1h1": "Category",
				"t1h2": "Last puchase time (days ago)",
				"t1h3": "Number of customers",
				"t2h1": "Category",
				"t2h2": "Total purchase times",
				"t2h3": "Percentage of customers",
				"t3h1": "Category",
				"t3h2": "Average purchase amount ($)",
				"t3h3": "Percentage of customers"
			},
			"Store": {
				"trx": "Transactions",
				"percent": "Percentage"
			},
			"Customers": {
				"selectDescription": "<strong>New customer definition </strong>The payment on that day is the first payment within",
				"tableStatus": {
					"title": "Category | Last purchase times(days ago) | Number of customers",
					"midField": "last payment time"
				},
				"tableFrequency": {
					"title": "Category | Total purchase times | Percentage of customers",
					"midField": "purchase times"
				},
				"tableContribution": {
					"title": "Category | Average purchase amount($) | Percentage of customers",
					"midField": "average purchase amount"
				},
				"tableCategorisation": {
					"selector": "All | Active Customers | Inactive Customers | Lost Customers",
					"title": "Low Frequency Customers | Mid Frequency Customers | High Frequency Customers",
					"titleColumn": "Low contribution customers | Mid contribution customers | High contribution customers"
				}
			}
		},
		"PaymentChannels": {
			"table": {
				"channel": "Channel",
				"status": "Status"
			},
			"subtitle": "Activate more payment channels"
		},
		"ActivateChannels": {
			"form": "App ID | Private key | Business registration document",
			"formDescription": "Please upload your business registration document.",
			"agree": "I agree with the <a>terms and conditions</a>"
		},
		"ChooseCoupon": {
			"example": "Example",
			"title": "Which coupon do you want to create"
		},
		"AddCoupon": {
			"type": "Coupon type",
			"f1": "Discount",
			"f2": "Name",
			"f3": "Valid time",
			"month": "1 month | 3 month",
			"placeholder": "Choose coupon's name",
			"t1": "Storewide % off",
			"t1f1": "Storewide | Off",
			"t2f1": "Off with | Spend",
			"t3f1": "Off with | Spend",
			"r1": "1.",
			"r2": "2. Coupon Valid time is",
			"r3": "3. Total Amount of Coupon is 1000",
			"r4": "4. Each Coupon can only be redeemed once",
			"r5": "5. The Coupon must be presented at cashier before payment to enjoy this offer",
			"r6": "6. The management reserves the right to amend the offer without prior notice",
			"tip": "Are you sure to publish the coupon",
			"rules": "Rules",
			"msg1": "Please enter an integer for percentage discount.",
			"msg2": "Please enter an integer between 1 and 99.",
			"msg3": "Oops! Currently, we only support less than 10,000 for minimum spending setting.",
			"msg4": "Please enter an positive number for minimum spending.",
			"msg5": "Please enter an positive number for amount discount.",
			"msg6": "Please enter an integer for minimum spending.",
			"msg7": "Please enter an integer for amount discount.",
			"msg8": "Please make sure your discount amount is less than your minimum spending.",
			"msg9": "Please input coupon discount before publish.",
			"msg10": "Please complete the value."
		},
		"Agreement": {
			"title": "Settlement Period"
		},
		"Contract": {
			"agree": "I Agree",
			"contact": "Contact MA",
			"info": "Contract confirmation",
			"cnt": "I have read through the contract and agree with it",
			"tip": "Contact",
			"mail": "E-mail",
			"phone": "Phone"
		},
		"ResetPwd": {
			"t1": "Reset Password",
			"t2": "Reset Refund Password",
			"err": "Not the same password"
		},
		"ServiceFee": {
			"t": "Service Fee Rate",
			"st": "Customer Bear the Service Fee",
			"r": "Service Fee Rate",
			"mf": "Merchant Bear the Service Fee",
			"sf": "Customer service fee cannot be set higher"
		},
		"Invoices": {
			"in": "Invoice number",
			"amount": "Amount",
			"gst": "GST",
			"tAmount": "Total amount",
			"month": "month",
			"placeholder": "Select month"
		}
	},
	"pageTitle": {
		"401": "401",
		"404": "404",
		"500": "500",
		"login": "Login",
		"dashboard": "Dashboard",
		"transactions": {
			"self": "Transactions",
			"view": "View transaction detail"
		},
		"customers": "Customers",
		"outlets": {
			"self": "Stores",
			"add": "Add new store",
			"view": "View store detail",
			"update": "Edit store"
		},
		"analytics": {
			"self": "Analytics",
			"trx": "Transactions",
			"customers": "Customers",
			"outlets": "Stores"
		},
		"reconciliation": "การกระทบยอด",
		"accounts": {
			"self": "ด้วยตัวเอง",
			"add": "เพิ่ม",
			"update": "ปรับปรุง"
		},
		"refunds": {
			"self": "ด้วยตัวเอง",
			"view": "ดู"
		},
		"settings": {
			"self": "ด้วยตัวเอง",
			"payment": "ชำระเงิน",
			"pwd": "Modify password",
			"refundPwd": "Modify refund password",
			"bank": "ธนาคาร",
			"qrcode": "QrCode"
		},
		"onBoarding": {
			"reset": "การตั้งใหม่",
			"agreement": "ข้อตกลง",
			"contract": "สัญญา",
			"serviceFee": "ค่าบริการ"
		},
		"coupons": {
			"self": "ด้วยตัวเอง",
			"choose": "เลือก",
			"add": "เพิ่ม",
			"edit": "แก้ไข",
			"view": "ดู",
			"agreement": "Agreement",
			"tips": "Tips"
		},
		"invoices": "ใบแจ้งหนี้",
		"settlements": "การสรุปยอดรายการ",
		"contract": "สัญญา"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/th/index.json
// module id = 1185
// module chunks = 1